<template lang="pug">
base-container
  avue-crud(
    ref="crud",
    :data="data",
    :table-loading="loading",
    :option="option",
    :page.sync="page",
    @search-change="searchChange",
    @search-reset="searchReset",
    @current-change="currentChange",
    @size-change="sizeChange",
    @refresh-change="refreshChange",
    @on-load="onLoad"
  )
    template(slot-scope="{row}", slot="showStatus")
      el-tag {{ row.showStatus === 0 ? '不显示' : '显示' }}
    template(slot-scope="{row}", slot="position")
      el-tag {{ row.position | positionLabel }}
    template(slot-scope="scope", slot="menuLeft")
      el-button(
        type="primary",
        icon="el-icon-plus",
        size="small",
        plain,
        @click.stop="handleAdd"
      ) 新增
    template(slot-scope="scope", slot="menu")
      el-button.none-border(
        icon="el-icon-edit",
        type="text",
        size="small",
        plain,
        @click.stop="rowUpdate(scope.row, scope.index)"
      ) 更新
      el-button.none-border(
        icon="el-icon-delete",
        type="text",
        size="small",
        plain,
        @click.stop="rowDel(scope.row, scope.index)"
      ) 删除
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
const CONFIRM_TITLE = "确定将所选数据删除？";
import { find } from "ramda";
import { getBannerList, delBanner } from "@/api/content";
import {
  positionEnum,
  ROUTER_BANNER_ADD_OR_UPDATE,
  ROUTER_BANNER_VIEW,
  showStatusEnum
} from "./const";

export default {
  name: "Banner",
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        searchShow: true,
        columnBtn: false,
        searchBtnText: "查询",
        emptyBtnText: "重置",
        stripe: true,
        searchSpan: 9,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 200,
        menu: true,
        column: [
          {
            label: "展示图片",
            prop: "url",
            dataType: "string",
            type: "img"
          },
          {
            label: "名称",
            prop: "title",
            overHidden: true,
            search: true
          },
          {
            label: "备注",
            prop: "comment",
            overHidden: true
          },
          {
            label: "展示位置",
            prop: "position",
            search: true,
            type: "select",
            // slot: true,
            props: {
              label: "name",
              value: "value"
            },
            dicUrl:'/mrhs-admin/dictionaries/getdict?typeCode=advert_show_type',
          },
          {
            label: "排序",
            prop: "orderby"
          },
          {
            label: "显示状态",
            prop: "showStatus",
            search: true,
            type: "select",
            slot: true,
            dicData: showStatusEnum
          },
          {
            label: "更新时间",
            prop: "updateDate",
            type: "daterange",
            width: 160
          }
        ]
      }
    };
  },
  filters: {
    positionLabel(value) {
      const item = find(x => x.value === value)(positionEnum);
      return item?.label ?? "";
    }
  },
  methods: {
    positionLabel(row) {
      console.log(row);
      const target = find(item => item.positon == row.position)(positionEnum);
      console.log(target);
      return target?.label ?? "";
    },
    rowView(row) {
      const { id } = row;
      //设置localStorage
      window.localStorage.setItem("bannerDetail", JSON.stringify(row));
      this.$router.push({ path: ROUTER_BANNER_VIEW, query: { id } });
    },
    rowUpdate(row, index, loading, done) {
      // 设置localStorage
      window.localStorage.setItem("bannerDetail", JSON.stringify(row));
      const { id } = row;
      this.$router.push({
        path: ROUTER_BANNER_ADD_OR_UPDATE,
        query: { id }
      });
    },
    handleAdd() {
      this.$router.push({
        path: ROUTER_BANNER_ADD_OR_UPDATE,
        query: { id: null }
      });
    },
    rowDel(row) {
      const { id } = row;
      this.$confirm(CONFIRM_TITLE, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delBanner({ id }).then(res => {
          if (res.code == "00000") {
            this.$message({
              type: "success",
              message: "操作成功",
              onClose: () => {
                this.onLoad(this.page);
              }
            });
          }
        });
      });
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getBannerList(page.currentPage, page.pageSize, params)
        .then(res => {
          const data = res.data;
          this.page.total = res.total;
          this.data = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
